
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.873 55.115"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7125","d":"M29.437 52.095L3.924 40.333c.088.053-2.257-1.006-3.924-1.959 0 1.422.357 4.029 1.683 4.732L26.66 54.334c2.208 1.041 3.159 1.041 5.551 0l24.977-11.229c1.234-.574 1.685-3.277 1.685-4.732-1.606.8-3.88 1.95-3.924 1.959zm0-49.006c.184.215.136.044 0 0zM1.683 31.344L26.66 42.572c2.208 1.041 3.159 1.041 5.551 0l24.977-11.228c1.234-.574 1.685-3.277 1.685-4.732-1.606.8-3.88 1.95-3.924 1.959L29.437 40.333 3.924 28.571c.089.054-2.257-1.005-3.924-1.959 0 1.422.357 4.029 1.683 4.732zm0-11.762L26.66 30.81c2.208 1.041 3.159 1.041 5.551 0l24.977-11.228c1.84-.857 1.9-4.5 0-5.545L32.211.849c-1.961-1.163-3.343-1.1-5.551 0L1.683 14.037c-1.9 1.229-1.961 4.504 0 5.545zM29.437 3.088l25.512 13.721-25.512 10.757L3.924 16.809z","fill":"#5fd95f"}})])
          )
        }
      }
    